import {useSnackbar} from "@dain/mui-components";
import {useTranslation} from "react-i18next";
import {useCallback, useEffect, useRef} from "react";
import {CommonTranslKey} from "../../../common/CommonTranslKey";
import {useClientLocator} from "../../../client/ApiClientLocator";
import {FormSessionTranslKey} from "../FormSessionTranslKey";

export interface FormSessionOpenerInternalUserPageProps {
    documentType: string | null;
    documentVersion: string | null;
    openerParams: Record<string, string>;
}

export function FormSessionOpenerInternalUserPage(props: Readonly<FormSessionOpenerInternalUserPageProps>) {
    const {documentType, documentVersion, openerParams} = props;

    const isInitialized = useRef(false);
    const {t} = useTranslation();
    const {formSessionClient, userClient} = useClientLocator();
    const snackbar = useSnackbar();

    const createSessionAndRedirectToUrl = useCallback((documentType: string, documentVersion: string) => {
        const formSessionCreateDto = {documentType, documentVersion, openerParams: Object.keys(openerParams).length > 0 ? openerParams : undefined};
        formSessionClient.createSessionAndReturnRedirectInfo(formSessionCreateDto)
            .then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else {
                    snackbar.error(t(FormSessionTranslKey.REDIRECT_TO_FORM_IS_NOT_ALLOWED), null);
                }
            })
            .catch((error) => snackbar.error(t(CommonTranslKey.UNEXPECTED_ERROR), error));
    }, [formSessionClient, openerParams, snackbar, t]);

    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;

            if (documentType && documentVersion) {
                createSessionAndRedirectToUrl(documentType, documentVersion);
            } else {
                snackbar.error(t(FormSessionTranslKey.MISSING_PARAMETERS), null);
                return;
            }
        }
    }, [userClient, snackbar, t, documentType, documentVersion, createSessionAndRedirectToUrl]);

    return null;
}
